import { render } from "./App.vue?vue&type=template&id=daa96a34"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=daa96a34&lang=scss"
import "./App.vue?vue&type=style&index=1&id=daa96a34&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__